import type { FeeSchedule } from '../types';

export function feeLabel(fees: FeeSchedule): string {
  const parts: string[] = [];
  if (fees.aum) parts.push('AUM');
  if (fees.flatFee) parts.push('Flat');
  if (fees.hourly) parts.push('Hourly');
  if (fees.commission) parts.push('Commission');
  if (fees.performance) parts.push('Performance');
  return parts.join(' · ') || 'Other';
}
